export default __webpack_public_path__ + "static/media/dis.38045a59.png";